<template>
  <div v-if="data.variations.length > 1">
    <SelectServiceVariationGroupItem
      :data="serviceVariationGroupData"
      :isExpanded="!isCollapsed"
      @click="isCollapsed = !isCollapsed"
      v-test="'service-variation-group'"
    />
    <div
      :class="[
        $style.variationsList,
        {
          [$style.collapsed]: isCollapsed
        }
      ]"
      :style="{
        backgroundColor: `${widgetSettings.color}0A`
      }"
    >
      <SelectServicesItem
        v-for="(service, index) in data.variations"
        :key="index"
        :data="{ ...service, description: '' }"
        isVariation
        v-test="'service-item'"
        @scrollTo="$emit('scrollTo', $event)"
        @submit="$emit('submit')"
      />
    </div>
  </div>
  <SelectServicesItem
    v-else
    :data="data.variations[0]"
    v-test="'service-item'"
    @scrollTo="$emit('scrollTo', $event)"
    @submit="$emit('submit')"
  />
</template>

<script setup lang="ts">
import type { ServiceVariationGroup } from '@/types';
import widgetSettings from '@/widget-settings';
import { computed, ref } from 'vue';

import { useBookingStore } from '@/stores/booking';
import SelectServiceVariationGroupItem from './SelectServiceVariationGroupItem.vue';
import SelectServicesItem from './SelectServicesItem.vue';

const props = defineProps<{
  data: ServiceVariationGroup;
}>();

defineEmits(['submit', 'scrollTo']);

const { serviceIds } = useBookingStore();

const hasSelectedService = computed(
  () =>
    !!serviceIds.find(
      (serviceId) =>
        !!props.data.variations.find((variation) => variation.id === serviceId)
    )
);
const isCollapsed = ref(!hasSelectedService.value);

const serviceVariationGroupData = computed(() => {
  let minPrice = props.data.variations[0].price;
  props.data.variations.forEach((variation) => {
    if (variation.price < minPrice) {
      minPrice = variation.price;
    }
  });

  return {
    name: props.data.name,
    price: minPrice,
    description: props.data.variations[0].description
  };
});
</script>

<style module lang="scss">
.variationGroup {
  cursor: pointer;
  padding-left: 16px;
}

.name {
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;

  &::first-letter {
    text-transform: uppercase;
  }
}
.variationsList {
  padding-left: 16px;
}

.collapsed {
  display: none;
}
</style>
